<template>
  <!-- eslint-disable max-len  -->
  <div class="panel-header">
    <div class="panel-title">
      <div class="back-btn" v-bind:class="{ active: displayBack }" @click="goBack">
        <svg
          width="32"
          height="32"
          enable-background="new 0 0 64 64"
          viewBox="0 0 64 64"
          xmlns="http://www.w3.org/2000/svg"
          style="fill: currentColor"
        >
          <path
            d="m54 30h-39.899l15.278-14.552c.8-.762.831-2.028.069-2.828-.761-.799-2.027-.831-2.828-.069l-17.448 16.62c-.755.756-1.172 1.76-1.172 2.829 0 1.068.417 2.073 1.207 2.862l17.414 16.586c.387.369.883.552 1.379.552.528 0 1.056-.208 1.449-.621.762-.8.731-2.065-.069-2.827l-15.342-14.552h39.962c1.104 0 2-.896 2-2s-.896-2-2-2z"
          />
        </svg>
      </div>
      <h1 v-if="firstPanel" class="title">
        {{ titleText }}
      </h1>
      <div v-else class="title">
        {{ titleText }}
      </div>

      <div class="rigth-btn"></div>
    </div>
    <div class="panel-help" :class="{ 'panel-help-left': helpTextLeft }" v-if="helpText">{{ helpText }}</div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  props: {
    displayBack: Boolean,
    firstPanel: Boolean,
    helpTextLeft: Boolean,
    titleText: String,
    helpText: String,
  },

  emits: ['onBack'],

  methods: {
    goBack() {
      this.$emit('onBack');
    },
  },
});
</script>

<style lang="scss" scoped>
.panel-header {
  margin-bottom: 1.75rem;
}

.panel-title {
  font-size: 1.5rem;
  font-weight: bold;
  display: flex;
  justify-content: space-between;
}

.panel-header .title {
  margin: 0;
  font-size: 1.2rem;
}

.panel-help {
  margin-top: 0.6rem;
}

.mobile-app .panel-header .panel-title {
  display: none !important;
}
.mobile-app .panel-header .panel-help {
  margin-top: 0;
}

.panel-help-left {
  text-align: left;
}
.back-btn {
  margin-top: 2px;
}

.rigth-btn,
.back-btn {
  width: 30px;
}

.back-btn.active svg {
  display: block;
}

.back-btn svg {
  cursor: pointer;
  display: none;
  width: 24px;
  height: 24px;
}
</style>
